import {customFetch as fetch} from './fetch';

export class Event {
    name: string;
    id: string;
    branchId: string;

    constructor(model: any = {}) {
        this.name = model.name;
        this.id = model.id;
        this.branchId = model.branchId;
    }
}

export class Competention {
    name: string;
    id: string;

    constructor(model: any = {}) {
        this.name = model.name;
        this.id = model.id;
    }
}

export class EmployeeType {
    name: string;
    id: string;

    constructor(model: any = {}) {
        this.name = model.name;
        this.id = model.id;
    }
}

export class Department {
    name: string;
    id: string;
    branchId: string;

    constructor(model: any = {}) {
        this.name = model.name;
        this.id = model.id;
        this.branchId = model.branchId;
    }
}

export class Function {
    name: string;
    id: string;

    constructor(model: any = {}) {
        this.name = model.name;
        this.id = model.id;
    }
}

export class Branch {
    id: string;
    name: string;
    address: string;


    constructor(model: any = {}) {
        this.id = model.id;
        this.name = model.name;
        this.address = model.address;
    }
}

export class Contract {
    name: string;
    id: string;
    employeeTypeId: string;
    hourlyRateFactor: number;
    deleted: boolean;

    constructor(model: any = {}) {
        this.id = model.id;
        this.name = model.name;
        this.employeeTypeId = model.employeeTypeId;
        this.hourlyRateFactor = model.hourlyRateFactor;
        this.deleted = model.deleted;
    }
}

export async function getAllEmployeeTypes(): Promise<EmployeeType[]> {
    const response = await fetch('/Employer/EmployeeType/All');
    return response.ok ? response.data : [];
}

export async function getAllDepartments(): Promise<Department[]> {
    const response = await fetch('/Employer/Department/All');
    return response.ok ? response.data : [];
}

export async function getAllFunctions(): Promise<Function[]> {
    const response = await fetch('/Employer/Function/All');
    return response.ok ? response.data : [];
}

export async function getAllCompetentions(): Promise<Competention[]> {
    const response = await fetch('/Employer/Competention/All');
    return response.ok ? response.data : [];
}

export async function getAllBranchCompetentions(): Promise<Competention[]> {
    const response = await fetch('/Employer/Competention/AllForBranch');
    return response.ok ? response.data : [];
}

export async function getAllBranches(): Promise<Branch[]> {
    const response = await fetch('/Employer/Branch/All');
    return response.ok ? response.data : [];
}

export async function getAllContracts(): Promise<Contract[]> {
    const response = await fetch('/Employer/Contract/AllContracts');
    return response.ok ? response.data : [];
}

export async function getAllCompanyBranches(companyId: string): Promise<Branch[]> {
    const response = await fetch(`/Admin/Branch/All/${companyId}`);
    return response.ok ? response.data : [];
}
